"use client"

import { Mobile, PC, Tablet, Notebook } from "../../views/ReactiveMode"
import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"

function VideoViewerFull(props) {
    const [translateY, setTranslateY] = useState(0)
    const navigate = useNavigate()

    const divRef = useRef(null)
    const handleScroll = () => {
        if (divRef.current != null) {
            if (
                divRef.current.getBoundingClientRect().y <= 0 &&
                divRef.current.getBoundingClientRect().height >= Math.abs(divRef.current.getBoundingClientRect().y)
            )
                setTranslateY(Math.abs(divRef.current.getBoundingClientRect().y)) // 스크롤 위치에 따라 translateY 설정
        }
    }

    useEffect(() => {
        // 스크롤 이벤트 리스너 추가
        window.addEventListener("scroll", handleScroll)

        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            window.removeEventListener("scroll", handleScroll)
        }
    }, [])

    const buttonClickEventHandler = () => {
        navigate(props.buttonUrl)
    }

    return (
        <>
            <PC>
                <section className="pc-image-viewer-full">
                    <div className="background" ref={divRef}>
                        <div className="title-layout">
                            <div className="title">{props.title}</div>
                            <div className="sub-title">{props.subTitle}</div>
                            {props.buttonTitle != null ? (
                                <button type="button" onClick={buttonClickEventHandler}>
                                    {props.buttonTitle}
                                </button>
                            ) : null}
                        </div>
                        <div className="layout" style={{ transform: `translateY(${translateY}px)` }}>
                            <video autoPlay muted loop playsInline >
                                <source src={process.env.REACT_APP_CDN_URL + "/videos/main2026.mp4"} type="video/mp4" />
                            </video>
                        </div>
                    </div>
                </section>
            </PC>

            <Notebook>
                <section className="pc-image-viewer-full">
                    <div className="background" ref={divRef}>
                        <div className="title-layout">
                            <div className="title">{props.title}</div>
                            <div className="sub-title">{props.subTitle}</div>
                            {props.buttonTitle != null ? (
                                <button type="button" onClick={buttonClickEventHandler}>
                                    {props.buttonTitle}
                                </button>
                            ) : null}
                        </div>
                        <div className="layout" style={{ transform: `translateY(${translateY}px)` }}>
                            <video loop autoPlay playsInline muted>
                                <source src={process.env.REACT_APP_CDN_URL + "/videos/main2026.mp4"} type="video/mp4" />
                            </video>
                        </div>
                    </div>
                </section>
            </Notebook>

            <Tablet>
                <section className="mobile-image-viewer-full">
                    <div className="background" ref={divRef}>
                        <div className="title-layout">
                            <div className="title">{props.title}</div>
                            <div className="sub-title">{props.subTitle}</div>
                            {props.buttonTitle != null ? (
                                <button type="button" onClick={buttonClickEventHandler}>
                                    {props.buttonTitle}
                                </button>
                            ) : null}
                        </div>
                        <div className="layout" style={{ transform: `translateY(${translateY}px)` }}>
                            <video loop autoPlay playsInline muted>
                                <source src={process.env.REACT_APP_CDN_URL + "/videos/main2026.mp4"} type="video/mp4" />
                            </video>
                        </div>
                    </div>
                </section>
            </Tablet>

            <Mobile>
                <section className="mobile-image-viewer-full">
                    <div className="background" ref={divRef}>
                        <div className="title-layout">
                            <div className="title">{props.title}</div>
                            <div className="sub-title">{props.subTitle}</div>
                            {props.buttonTitle != null ? (
                                <button type="button" onClick={buttonClickEventHandler}>
                                    {props.buttonTitle}
                                </button>
                            ) : null}
                        </div>
                        <div className="layout" style={{ transform: `translateY(${translateY}px)` }}>
                            <video loop autoPlay playsInline muted>
                                <source src={process.env.REACT_APP_CDN_URL + "/videos/main2026_m.mp4"} type="video/mp4" />
                            </video>
                        </div>
                    </div>
                </section>
            </Mobile>
        </>
    )
}

export default VideoViewerFull
